module.exports = __webpack_public_path__ + "static/img/banner4.af8344d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/banner4.jpg
// module id = KgrW
// module chunks = 1